exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-success {\n  padding: 1rem 2rem;\n}\n.update-success .icon {\n  display: block;\n  margin: auto;\n  max-width: 64px;\n}", ""]);

// exports
